import Grid from '@mui/material/Grid';
import { useTranslation } from 'react-i18next';

import LocalizedTextField from 'src/common/components/form/LocalizedTextField';
import { LanguageKeys } from 'src/common/constants/languages';
import { SocialShareLocaleFields } from 'src/interfaces/SocialShare';

interface Props {
  locales: Record<LanguageKeys, SocialShareLocaleFields>;
  editorLang: LanguageKeys;
  onEditorLangChange: (lang: LanguageKeys) => void;
  onLocalesChange: (locales: Record<LanguageKeys, SocialShareLocaleFields>) => void;
}

export default function SocialShareTextFields({
  locales,
  editorLang,
  onEditorLangChange,
  onLocalesChange,
}: Props) {
  const { t } = useTranslation();

  const updateField = (field: keyof SocialShareLocaleFields, value: Record<LanguageKeys, string>) => {
    onLocalesChange({
      en: { ...locales.en, [field]: value.en },
      hu: { ...locales.hu, [field]: value.hu },
      ro: { ...locales.ro, [field]: value.ro },
    });
  };

  return (
    <Grid container spacing={2}>
      <Grid size={{ xs: 12 }}>
        <LocalizedTextField
          label={t('system.socialSharing.titleField')}
          value={{
            en: locales.en.title,
            hu: locales.hu.title,
            ro: locales.ro.title,
          }}
          onChange={value => updateField('title', value)}
          editorLang={editorLang}
          onEditorLangChange={onEditorLangChange}
        />
      </Grid>
      <Grid size={{ xs: 12 }}>
        <LocalizedTextField
          label={t('system.socialSharing.descriptionField')}
          helperText={t('system.socialSharing.descriptionHint')}
          value={{
            en: locales.en.description,
            hu: locales.hu.description,
            ro: locales.ro.description,
          }}
          onChange={value => updateField('description', value)}
          editorLang={editorLang}
          onEditorLangChange={onEditorLangChange}
          multiline
          minRows={3}
        />
      </Grid>
    </Grid>
  );
}
